function fgInt(n) {
  return { value: n | 0, __fgInt: true };
}
function isFgInt(v) {
  return typeof v === "object" && v !== null && v.__fgInt === true;
}

export { fgInt, isFgInt };
//# sourceMappingURL=fg-integer.js.map
